import type { User } from '@adornis/buchungsheld-db/entities/user.js';
import { stateful, useObservable } from '@adornis/functional-lit/stateful.js';
import { searchParamsSignal } from '@adornis/router/client/routing-state-signal.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { html } from 'lit';
import * as m from '../../../../localization/out/messages.js';
import { UserToolbar } from '../../components/user-toolbar.js';
import { RegisterLoginOrRegister } from './register-login-or-register.js';
import { RegisterOnboarding } from './register-onboarding.js';
import { registerRouter } from './register-routes.js';

// Simple credential-collection screen matching the provided wireframe
// Accepts selected job position IDs via query param `jobs` as a comma-separated list
export const RegisterRegister = stateful(() => {
  const jobsParam = searchParamsSignal.value.get('jobs') ?? '';
  const selectedJobIDs = jobsParam
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

  const user = useObservable(() => currentUser<User>(), []);
  // TODO (low prio) add loading state while loading, user registering and mail confirmation

  if (selectedJobIDs.length === 0)
    return html`
      <div class="flex min-h-dvh flex-col h-full">
        <div class="flex-1">
          <div class="p-4 sm:p-8">
            <div class="mx-auto w-full max-w-3xl flex flex-col gap-4">
              <div class="flex flex-row items-center justify-between">
                <div>
                  <button class="btn btn-ghost p-0" @click=${() => registerRouter.goTo('root')}>
                    <span class="icon-[material-symbols--arrow-back]"></span>
                    ${m.cancel()}
                  </button>
                </div>
                ${UserToolbar()}
              </div>
              <div class="alert alert-error">
                <span>${m.no_jobs_selected()}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

  return html`
    <div class="flex min-h-dvh flex-col h-full overflow-y-auto">
      <div class="flex-1">
        <div class="p-4 sm:p-8">
          <div class="mx-auto w-full max-w-3xl flex flex-col gap-4">
            <div class="flex flex-row items-center justify-between">
              <div>
                <button class="btn btn-ghost p-0" @click=${() => registerRouter.goTo('root')}>
                  <span class="icon-[material-symbols--arrow-back]"></span>
                  ${m.cancel()}
                </button>
              </div>
              ${UserToolbar()}
            </div>
            <!-- Schritt 1 -->
            ${!!user
              ? RegisterOnboarding()
              : html`
                  <section class="card bg-base-100 shadow-md">
                    <div class="card-body gap-6">
                      <h2 class="card-title">Schritt 1</h2>

                      <!-- Selected jobs info (from query params) -->
                      ${selectedJobIDs.length
                        ? html`<div class="alert alert-info">
                            <span>${m.selected_jobs_linked({ count: selectedJobIDs.length })}</span>
                          </div>`
                        : html``}
                      ${RegisterLoginOrRegister()}
                    </div>
                  </section>
                `}
          </div>
        </div>
      </div>
    </div>
  `;
});
